import React, { useState } from 'react'
import { Classes } from '@blueprintjs/core'
import { IconButton, Confirmation, Dialog } from '@ui'
import ImportFlow from './ImportFlow'
import { NavigateFn } from '@reach/router'

interface EmployeeImportDialog {
  navigate: NavigateFn
  reload?: () => void
}

export default function EmployeeImportFlow({ navigate, reload }: EmployeeImportDialog) {
  const [dirty, setDirty] = useState(false)

  function onClose() {
    navigate && navigate('?newItem')
  }

  return (
    <Dialog
      isOpen={true}
      style={{ position: 'relative', minWidth: 800 }}
      canEscapeKeyClose={false}
      canOutsideClickClose={false}
      transitionDuration={200}
      isCloseButtonShown={false}
      toolbar={
        <div className="dialog-buttons">
          {dirty ? (
            <Confirmation text="Discard unsaved changes?" onConfirm={onClose}>
              <IconButton minimal round tooltip="Close" iconName="times" />
            </Confirmation>
          ) : (
            <IconButton minimal round tooltip="Close" iconName="times" onClick={onClose} />
          )}
        </div>
      }
      body={
        <div className={Classes.DIALOG_BODY}>
          <ImportFlow
            dirty={dirty}
            setDirty={(dirty) => setDirty(dirty)}
            onClose={onClose}
            reload={reload}
          />
        </div>
      }
    />
  )
}
